module.exports = __webpack_public_path__ + "img/data-not-found.d8f03e7f.svg";